import * as React from 'react';
import classnames from 'classnames';

const Loader = ({ className  })=>/*#__PURE__*/ React.createElement("div", {
        "aria-hidden": "true",
        className: classnames('loader', className),
        "data-t": "loader"
    })
;

export { Loader as default };
//# sourceMappingURL=Loader.js.map
